export default {
    apiUrl: function () {
        if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
            return 'http://localhost:8178/v1/'
        } else {
            return 'https://api.tdadental.com/v1/'
        }
    },
    downloadUrl: function () {
        if (location.hostname === 'localhost' || location.hostname === '127.0.0.1') {
            return 'http://localhost:8178/'
        } else {
            return 'https://app.tdadental.com/'
        }
    },
    getProfileSettings: function () {
        let localSettings = localStorage.getItem('portalSettings')
        if (!localSettings) {
            return this.getProfileDefaults()
        }
        return localSettings
    },
    getProfileDefaults: function () {
        return {
            perPage: [15, 35, 60, 100],
            perPageOptions: [
                [15, 35, 60, 100],
                [25, 50, 100, 500]
            ],
            idleTimeout: 60000,
            idleTimeoutOptions: [
                {
                    text: '30 Seconds',
                    value: 30000
                },
                {
                    text: '1 minute',
                    value: 60000
                },
                {
                    text: '2 minutes',
                    value: 120000
                },
                {
                    text: '5 minutes',
                    value: 300000
                },
            ],
            logoutTimeoutOptions: [
                {
                    text: '1 minute',
                    value: 60
                },
                {
                    text: '5 minutes',
                    value: 300
                },
                {
                    text: '10 minutes',
                    value: 600
                }
            ]
        }
    },
    applicationSettings: {
        version: '1.0 #719a79e',
        requestHipaa: false
    }
}

export const userPreferences = {
    screenIdle: (localStorage.getItem('screenIdle')) ? localStorage.getItem('screenIdle') : 60000,
    logoutTimeout: (localStorage.getItem('logoutTimeout')) ? localStorage.getItem('logoutTimeout') : 600,
}
